import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Panel } from '../../../../../common/panel'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Content } from './Content'
import { selectIds } from './store/slice'
import {
  downloadCapitalEarningLeverage,
  postCapitalEarningLeverage,
} from './store/thunk'

export const CapitalEarningLeverage = ({ settingsFS }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const { currency, unitName, multiplier } = useFormatCurrency(
    SCREEN.INDUSTRY_ANALYSIS,
  )
  const ids = useSelector(selectIds)
  const locale = useSelector((state) => state.i18n.locale)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(postCapitalEarningLeverage({ organizationId, ...settingsFS }))
  }, [locale])

  return (
    <Panel
      isI18n
      height={500}
      label="companyAnalysis.industryAnalysis.CAPITAL_EARNINGS_LEVERAGE"
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () =>
          downloadCapitalEarningLeverage({
            organizationId,
            currency,
            currencyUnit: {
              multiplier,
              value: unitName,
            },
            ...settingsFS,
          }),
      }}
    >
      <Content />
    </Panel>
  )
}
